import React, { useState } from "react";
import Select from "react-select";
import reactSelectStyle from "./reactSelectStyle";

const MsaSelect = ({
  input,
  inputOnChange,
  passLabelBack,
  meta,
  formApi,
  formValues,
  schemaProps: {
    machine_name,
    disableWhenField,
    parent_machine_name,
    skipFirstReset,
    secondaryCounty,
    updateBls,
    clearSchema,
  },
  areaCountyOptions,
  counties,
  ...rest
}) => {
  const [disableFlag, setDisableFlag] = useState(false);
  const clearFields = () => {
    clearSchema.forEach((c) => {
      let fieldToClear = parent_machine_name
        ? `${parent_machine_name}[0]${c}`
        : c;
      formApi.change(fieldToClear, null);
    });
  };
  let lookup_state, lookup_state_addendum, OES_options;
  let disableField =
    rest && rest.tableName
      ? rest.tableName + disableWhenField
      : disableWhenField;

  if (Array.isArray(disableWhenField)) {
    disableField = disableWhenField[0].when;
  }
  if (
    formApi &&
    formApi.getFieldState(disableField) &&
    formApi.getFieldState(disableField).value !== undefined
  ) {
    lookup_state_addendum = formApi.getFieldState(disableField).value;
  }
  lookup_state = parent_machine_name
    ? formValues &&
      formValues[parent_machine_name] &&
      formValues[parent_machine_name][0] &&
      formValues[parent_machine_name][0][disableWhenField]
    : formValues[disableField];

  const [stateValue, setStateValue] = useState(lookup_state);
  const [skipReset, setSkipReset] = useState(skipFirstReset || false); // in cases where we want to skip the first reset (section F of 9035)
  const machine_name_modified = parent_machine_name
    ? `${parent_machine_name}[0]${machine_name}`
    : machine_name;
  let options;
  const handleChange = (selectedOption) => {
    input.onChange(selectedOption);

    if (updateBls) {
      if (selectedOption.bls && typeof updateBls == "string") {
        const bls_machine_name_modified = parent_machine_name
          ? `${parent_machine_name}[0]${updateBls}`
          : updateBls;
        formApi.change(bls_machine_name_modified, selectedOption.bls);
      }
      if (updateBls.machine_name_id) {
        const bls_machine_name_id_modified = parent_machine_name
          ? `${parent_machine_name}[0]${updateBls.machine_name_id}`
          : updateBls.machine_name_id;
        formApi.change(bls_machine_name_id_modified, selectedOption.blsAreaId);
      }
    }
    // dynamic update to grab blsAreaId and set it on field passed in
    setSkipReset(false);
  };

  if (counties === false) {
    return (
      <div className="county-select-input">
        <Select
          {...input}
          styles={reactSelectStyle}
          id={machine_name}
          isDisabled={disableFlag}
          value={input.value}
          isSearchable={true}
          backspaceRemovesValue={true}
          placeholder="Type search term here"
          hideSelectedOptions={true}
        />
      </div>
    );
  }
  if (stateValue && counties) {
    options = counties[stateValue];
    options = options || [];

    let prepareSet = options.map((opt) => {
      return { bls: opt.bls, blsAreaId: opt.blsAreaId };
    });

    const setOptions = new Set(prepareSet);

    options = Array.from(setOptions).map((opt) => {
      return { label: opt.bls, value: opt.bls, blsAreaId: opt.blsAreaId };
    });

    const keys = {};
    const uniqueOptions = [];
    for (let option of options) {
      if (!keys[option.label]) {
        keys[option.label] = 1;
        uniqueOptions.push(option);
      }
    }
    if (uniqueOptions && uniqueOptions.length > 0) {
      uniqueOptions.sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
    }
    options = uniqueOptions;
  }

  if (lookup_state) {
    if (counties && counties.length > 0) {
      setDisableFlag(false);
      options = counties[lookup_state];
    }

    // change state value if different from current value
    if (lookup_state && lookup_state !== stateValue && counties) {
      setStateValue(lookup_state);
      setDisableFlag(false);
      // change the state? reset the county
      if (
        !skipReset &&
        (lookup_state !== "- Select -" || lookup_state != undefined)
      ) {
        formApi.change(machine_name_modified, undefined);
        if (updateBls) {
          // let name;
          let bls_machine_name = parent_machine_name
            ? `${parent_machine_name}[0]${updateBls}`
            : updateBls;
          if (updateBls.hasOwnProperty("type")) {
            bls_machine_name = parent_machine_name
              ? `${parent_machine_name}[0]${updateBls.machine_name}`
              : updateBls.machine_name;
          }
          formApi.change(bls_machine_name, undefined);
        }
        input.onChange(undefined);
      }

      if (options && options.length > 0) {
        options.sort(function (a, b) {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        });
      }
    }
  }
  let setDisabled;
  if (
    areaCountyOptions &&
    areaCountyOptions.areaOptions !== undefined &&
    areaCountyOptions.countyOptions !== undefined &&
    areaCountyOptions.areaOrCounty !== undefined &&
    areaCountyOptions.state !== undefined &&
    areaCountyOptions.state !== "- Select -" &&
    !areaCountyOptions.ignoreStates.includes(areaCountyOptions.state)
  ) {
    setDisabled = true;
    let select_options = areaCountyOptions[areaCountyOptions.areaOrCounty];
    OES_options = select_options;
    if (secondaryCounty) {
      OES_options = areaCountyOptions["secondaryCountyOptions"];
    }
  }
  // array of values to check to determine if field should be disabled

  if (disableWhenField && Array.isArray(disableWhenField)) {
    setDisabled = false;
    disableWhenField.forEach((f) => {
      let check_val = formValues[f.when];
      if (Array.isArray(f.is)) {
        f.is.forEach((fis) => {
          if (check_val === fis) {
            setDisabled = true;
          }
        });
      }
      if (typeof f.is === "string") {
        if (check_val === f.is) {
          setDisabled = true;
        }
      }
    });
  }

  let isDisabled = setDisabled || disableFlag;
  return (
    <div className="county-select-input">
      <Select
        {...input}
        styles={reactSelectStyle}
        id={machine_name}
        isDisabled={isDisabled}
        options={options && options.length > 0 ? options : OES_options}
        onChange={(e) => {
          handleChange(e);
          clearSchema && clearFields();
          inputOnChange && inputOnChange(e.value);
          passLabelBack && passLabelBack(e);
        }}
        value={input.value}
        isSearchable={true}
        backspaceRemovesValue={true}
        placeholder="Type search term here"
        hideSelectedOptions={true}
      />
    </div>
  );
};

export default MsaSelect;
